import React from "react";

/** Progress row — fully inline styles, no CSS class dependency for layout
 *  `value` is what's displayed (can be a formatted string like "1,204").
 *  `rawValue` is the actual number to use for the % calculation when `value`
 *  has been formatted and can't be parsed back reliably (e.g. "1,204" -> NaN).
 *  `rawPct` skips the calculation entirely when the caller already knows the %.
 */
const ProgressRow = ({ label, value, max, rawValue, rawPct, color, badge, loading }) => {
  const numerator = rawValue !== undefined ? rawValue : parseFloat(value);
  const pct =
    rawPct !== undefined ? rawPct : max > 0 ? Math.round((numerator / max) * 100) : 0;

  return (
    <div style={{ marginBottom: "10px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "5px",
        }}
      >
        <span style={{ fontSize: "12px", color: "#343a40", fontWeight: 500 }}>{label}</span>
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          {badge && (
            <span
              style={{
                fontSize: "10px",
                padding: "2px 7px",
                borderRadius: "20px",
                fontWeight: 700,
                background: "#e8f5e9",
                color: "#2e7d32",
              }}
            >
              {badge}
            </span>
          )}
          <span
            style={{
              fontSize: "12px",
              fontWeight: 700,
              color: "#212529",
              minWidth: "24px",
              textAlign: "right",
            }}
          >
            {loading ? "…" : value}
          </span>
        </div>
      </div>
      <div
        title={`${pct}%`}
        style={{
          display: "block",
          width: "100%",
          height: "7px",
          background: "#f1f3f5",
          borderRadius: "99px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: loading ? "0%" : `${pct}%`,
            height: "100%",
            background: color,
            borderRadius: "99px",
            minWidth: pct > 0 ? "6px" : "0",
            transition: "width 0.72s cubic-bezier(0.22, 1, 0.36, 1)",
          }}
        />
      </div>
    </div>
  );
};

export default ProgressRow;
